import base from './base';

const companies = {
  getCompanies(id: number) {
    return base.get(`/companies/${id}`);
  },
};

export default companies;
